import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from "react-redux";
import {persistor, store} from "./redux/store";
import {BrowserRouter} from "react-router-dom";
import {ApolloClient, ApolloProvider, createHttpLink, from, InMemoryCache} from "@apollo/client";
import {PersistGate} from "redux-persist/integration/react";
import {setContext} from "@apollo/client/link/context";
import axios from "axios";

import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import * as buffer from "buffer";
window.Buffer = buffer.Buffer;

export const SERVER_ADDRESS = 'https://dry-river-37620.herokuapp.com';
// export const SERVER_ADDRESS = 'http://localhost:1337'
// export const SERVER_ADDRESS = 'http://ec2-52-78-145-195.ap-northeast-2.compute.amazonaws.com:1337'
export const TOSS_CLIENT_KEY = "live_ck_oeqRGgYO1r5qYgyzKzprQnN2Eyaz";
export const TOSS_SUB_CLIENT_KEY = "live_ck_Z0RnYX2w532DBAQ0NkPrNeyqApQE";

const setupAxios = (axios, store) => {
    const exceptApi = ['/auth'];
    axios.interceptors.request.use(
        config => {
            const {
                auth: {token}
            } = store.getState();

            // 우리 API 서버 호출시에만 authToken을 넣어준다. 예외 API의 경우에는 넣지 않는다. --blackcat
            if (token && config.url.startsWith(SERVER_ADDRESS)) {
                const isExcept = exceptApi.reduce((acc, current) =>
                    acc + config.url.startsWith(SERVER_ADDRESS + current) ? 1 : 0, 0);
                if (!isExcept) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
            }
            return config;
        },
        err => Promise.reject(err)
    );
}

const authLink = setContext((_, { headers }) => {
    const token = store.getState().auth.token;
    const tokenInfo = store.getState().auth.tokenInfo;
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : '',
        },
    };
});

const httpLink = createHttpLink({ uri: SERVER_ADDRESS + '/graphql' });

const defaultOptions = {
    watchQuery: {
        fetchPolicy: 'network-only',
    },
    query: {
        fetchPolicy: 'network-only',
    }
}

const client = new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions,
});

setupAxios(axios, store);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
      <Provider store={store}>
          <PersistGate persistor={persistor}>
              <ApolloProvider client={client}>
                  <BrowserRouter>
                      <App />
                  </BrowserRouter>
              </ApolloProvider>
          </PersistGate>
      </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
